import { HttpInterceptorFn } from '@angular/common/http';
import { isBackendUrl } from './backend-url';

/**
 * Stellt sicher, dass jede ausgehende Anfrage das Session-Cookie enthält.
 *
 * Die Authentifizierung basiert auf Sessions (HttpOnly `JSESSIONID`-Cookie,
 * vom Backend gesetzt). Browser hängen Cookies nur an `XMLHttpRequest`/
 * `fetch`-Aufrufe an, wenn `withCredentials` gesetzt ist. Dieser Interceptor
 * aktiviert es daher zentral für Requests an Origin und Pfad des Backends. Es gibt
 * bewusst keine Token-Behandlung: die SPA sieht oder speichert niemals einen
 * Zugriffstoken.
 */
export const credentialsInterceptor: HttpInterceptorFn = (req, next) =>
  next(isBackendUrl(req.url) ? req.clone({ withCredentials: true }) : req);
